import { render, staticRenderFns } from "./shixu.vue?vue&type=template&id=673e3f64&scoped=true&"
import script from "./shixu.vue?vue&type=script&lang=ts&"
export * from "./shixu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e3f64",
  null
  
)

export default component.exports